import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IJob,
    IStartProcess,
} from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const enum StopStrategy {
    SoftStop = 1,
    Kill = 2,
}

@Injectable()
export class JobService extends ODataService<IJob, number> {
    protected _endpoint = '/odata/Jobs';
    private _mediaDownloadUrl = `/odata/ExecutionMedia/UiPath.Server.Configuration.OData.DownloadMediaByJobId`;

    constructor(http: HttpClient) {
        super(http, MapperService.jobMap);
    }

    public startJobs(startProcessArgs: IStartProcess): Observable<boolean> {
        const url = `${this._endpoint}/UiPath.Server.Configuration.OData.StartJobs`;
        const payload = {
            'startInfo': {
                'ReleaseKey': startProcessArgs.releaseKey,
                'RobotIds': startProcessArgs.robotIds,
                'JobsCount': startProcessArgs.jobsCount,
                'Strategy': startProcessArgs.strategy,
                'InputArguments': startProcessArgs.inputArguments != null ?
                    JSON.stringify(startProcessArgs.inputArguments) :
                    null,
            },
        };
        return this._http.post(url, payload)
            .pipe(
                map(() => true),
            );
    }

    public stopJob(jobId: number, kill: boolean): Observable<boolean> {
        const action = 'UiPath.Server.Configuration.OData.StopJob';
        const payload = JSON.stringify({
            strategy: this._getStrategy(kill),
        });
        return this._http.post(`${this._endpoint}(${jobId})/${action}`, payload)
            .pipe(
                map(() => true),
            );
    }

    public stopJobs(jobIds: number[], kill: boolean): Observable<boolean> {
        const action = 'UiPath.Server.Configuration.OData.StopJobs';
        const payload = JSON.stringify({
            jobIds,
            strategy: this._getStrategy(kill),
        });
        return this._http.post(`${this._endpoint}/${action}`, payload)
            .pipe(
                map(() => true),
            );
    }

    public resumeJob(jobKey: string): Observable<boolean> {
        const action = 'UiPath.Server.Configuration.OData.ResumeJob';
        const payload = JSON.stringify({
            jobKey: jobKey,
        });
        return this._http.post(`${this._endpoint}/${action}`, payload)
            .pipe(
                map(() => true),
            );
    }

    public getMediaDownloadUrl(job: IJob) {
        return `${this._mediaDownloadUrl}(jobId=${job.id})`;
    }

    private _getStrategy(kill: boolean) {
        return (kill ? StopStrategy.Kill : StopStrategy.SoftStop).toString();
    }
}
